import axios from 'axios'

/**
 * @desc Fetches Supplier Draft Orders
 */
export const fetchDraftOrders = () =>
  axios.get(`/authenticated/supplier-orders/draft`).then((res) => res.data)

/**
 * @desc Fetches Supplier DPOs and POs PDFs
 * @desc getSupplierOrderPdf in BFF
 */
export const fetchOrderPDF = (orderId, getDeliveryNote = false) =>
  axios
    .get(
      `/authenticated/supplier-orders/${orderId}/pdf?deliveryNote=${getDeliveryNote}`,
      { method: 'GET', responseType: 'blob' }
    )
    .then((res) => res.data)

export const fetchSupplierOrderInvoicePdfUrl = (orderId) =>
  axios
    .get(`/authenticated/supplier-orders/${orderId}/pdf/invoice/url`)
    .then((res) => res.data)

/**
 * @desc Fetches Supplier Purchase Orders that are Awaiting Delivery
 */
export const fetchAwaitingDeliveryFinalOrders = () =>
  axios
    .get(`/authenticated/supplier-orders/final/awaiting-delivery`)
    .then((res) => res.data)

/**
 * @desc Fetches Supplier Purchase Orders that are Awaiting Despatch
 */
export const fetchAwaitingDespatchFinalOrders = () =>
  axios
    .get(`/authenticated/supplier-orders/final/awaiting-despatch`)
    .then((res) => res.data)

/**
 * @desc Fetches Delivered Supplier Purchase Orders
 * @param {String} query - Includes several search parameters
 */
export const fetchDeliveredFinalOrders = (page, size, query) => {
  let baseQuery = `page=${page}&size=${size}`
  if (query) baseQuery += `&${query}`

  return axios
    .get(`/authenticated/supplier-orders/final/delivered?${baseQuery}`)
    .then((res) => res.data)
}

/**
 * @desc Fetches Supplier Order Details
 */
export const fetchOrderDetails = (orderId) =>
  axios.get(`/authenticated/supplier-orders/${orderId}`).then((res) => res.data)

/**
 * @desc Submit Purchase Order (for Draft and Purchase orders)
 * @desc API updateSupplierOrder in BFF
 */
export const submitOrder = (orderId, request) =>
  axios
    .put(`/authenticated/supplier-orders/${orderId}`, request)
    .then((res) => res.data)

export const updateServiceCompletedDates = (orderId, request) =>
  axios
    .put(
      `/authenticated/supplier-orders/${orderId}/service-completed-dates`,
      request
    )
    .then((res) => res.data)

/**
 * @desc Cancel Purchase Order (only allowed for DRAFT)
 */
export const cancelOrder = (orderId, request) =>
  axios
    .put(`/authenticated/supplier-orders/${orderId}/cancel`, request)
    .then((res) => res.data)

/**
 * @desc Fetches Supplier Order Statistics
 * @desc API getSupplierOrderStatusStatistics in BFF
 */
export const fetchOrderStatistics = () =>
  axios.get(`/authenticated/supplier-orders/statistics`).then((res) => res.data)
